// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__SFkY6","emails":"CreateEditClinics_emails__1cl9m","emailTagLabel":"CreateEditClinics_emailTagLabel__2FClz"};